import styled from 'styled-components'

export const SearchTableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .rt-TableRootTable {
    min-width: 100%;
    width: max-content;
  }

  tbody tr:focus td {
    background-color: var(--gecko-table-row-bg);
  }
`
